import { render, staticRenderFns } from "./VideoSort.vue?vue&type=template&id=2ca2adca&scoped=true&"
import script from "./VideoSort.vue?vue&type=script&lang=js&"
export * from "./VideoSort.vue?vue&type=script&lang=js&"
import style0 from "./VideoSort.vue?vue&type=style&index=0&id=2ca2adca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2adca",
  null
  
)

export default component.exports